export default {
  zh: {
    title: '设置分享',
    buttonTeams: '分享给其他用户或群组'
  },
  en: {
    title: 'Shared To',
    buttonTeams: 'Add User or Team to Share'
  }
};



// WEBPACK FOOTER //
// ./src/views/Section_SharedTo/i18n.js